/**
 * Import Lib & assets
 */

import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import t from "theme";

/**
 * import components
 */

import { Svg__info, Svg__cross } from "components/svg/svg";
/**
 * styled components
 */

const Container = styled.i`
  display: inline-block;
  position: relative;
  font-family: ${t.font.primary};

  &:hover::after {
    display: block;
  }

  &::after {
    content: "${props => props.content}";
    display: none;
    position: absolute;
    z-index: 4;
    top: 50%;
    left: 50%;
    width: 310px;
    padding: 7px 8px 4px 9px;
    background-color: ${t.color.white};
    ${t.mixins.rem(14, 19)}
    color: ${t.color.darkGrey};
    border: solid 0.5px #666666;
    border-radius: 4px;
    box-shadow: 0px 2px 16px 0 rgba(0, 0, 0, 0.42);
    transform: translate(0, -100%);
    text-align: center;
  }

  ${t.mixins.sm(`
    position: initial;

    &::hover::after {
      display: none;
    }
    &::after {
      display: none !important;
    }
  `)}
`;

const Tooltip = styled.div`
  display: none;

  ${t.mixins.sm(`
    ${t.mixins.flex()}
    position: absolute;
    z-index: 10;
    right: 38px;
    left: -50%;
    min-width: 320px;
    max-width: 100%;
    padding: 9px 13px;
    background-color: ${t.color.white};
    ${t.mixins.rem(14, 19)}
    color: ${t.color.darkGrey};
    border: solid 0.5px #666666;
    border-radius: 4px;
    box-shadow: 0px 2px 16px 0 rgba(0, 0, 0, 0.42);
    transform: translate(50%, -70px);
  `)}
`;

const Content = styled.p`
  padding-right: 13px;
`;

const Button = styled.button`
  width: 11px;
`;

const Close = styled.button`
  width: 11px;
  transform: scale(0.6);
`;
/**
 * tooltip component is..
 */

const Content__tooltip = ({ content, className, size = 21 }) => {
  const [opened, setOpened] = useState(false);

  const open = () => setOpened(true);

  const close = () => setOpened(false);

  return (
    <Container content={content} className={className}>
      <Button onClick={() => open()}>
        <Svg__info size={size} />
      </Button>
      {opened && (
        <Tooltip>
          <Content>{content}</Content>
          <Close
            onClick={() => {
              close();
            }}
          >
            <Svg__cross color={t.color.darkGrey} />
          </Close>
        </Tooltip>
      )}
    </Container>
  );
};

export default Content__tooltip;

Content__tooltip.propTypes = {
  /**
      A custom style object
      */
  style: PropTypes.object,
};

Content__tooltip.defaultProps = {
  style: {},
};

/*
    import Content__tooltip from 'components/content/tooltip/content__tooltip'
    <Content__tooltip />
  */
